function ownKeys(e, r) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function(r2) {
      return Object.getOwnPropertyDescriptor(e, r2).enumerable;
    })), t.push.apply(t, o);
  }
  return t;
}
function _objectSpread(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), true).forEach(function(r2) {
      _defineProperty(e, r2, t[r2]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function(r2) {
      Object.defineProperty(e, r2, Object.getOwnPropertyDescriptor(t, r2));
    });
  }
  return e;
}
function _defineProperty(e, r, t) {
  return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: true, configurable: true, writable: true }) : e[r] = t, e;
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == typeof i ? i : i + "";
}
function _toPrimitive(t, r) {
  if ("object" != typeof t || !t)
    return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != typeof i)
      return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
import range from "lodash/range";
import { jsx } from "panel";
import { SvgIconEl } from "common/components/svg-icon";
import { handleKeyPress } from "common/util/focusable";
import { SidenavItemEl } from "./sidenav-item";
import { NestingOrder } from "./types";
function Loader() {
  return /* @__PURE__ */ jsx("div", { sel: ".loader", attrs: {
    elref: "sidenavLoader"
  }, "data-sentry-component": "Loader", "data-sentry-source-file": "template.tsx" }, /* @__PURE__ */ jsx("div", { sel: ".mp-skeleton-header" }), range(9).map((_) => /* @__PURE__ */ jsx("div", { sel: ".mp-skeleton-large" })));
}
function SidenavItemWithNestedItems(props) {
  var _item$nestedItems, _item$nestedItems2;
  const section = props.section;
  const item = props.item;
  const idx = props.idx;
  const sectionIdx = props.sectionIdx;
  const selectedItemValue = props.selectedItemValue;
  const hoveredItemValues = props.hoveredItemValues;
  const sectionDragDisabled = props.sectionDragDisabled;
  const activeDragSectionIdx = props.activeDragSectionIdx;
  const onItemDrop = props.onItemDrop;
  const onItemDragStart = props.onItemDragStart;
  const onItemDragEnd = props.onItemDragEnd;
  const onSelectItem = props.onSelectItem;
  const toggleItemChildren = props.toggleItemChildren;
  const onItemOverflowMenuChange = props.onItemOverflowMenuChange;
  const onItemOverflowMenuSelect = props.onItemOverflowMenuSelect;
  const onItemMouseEntered = props.onItemMouseEntered;
  const preventDefaultNavigate = props.preventDefaultNavigate;
  const isNestedDashboardsEnabled = props.isNestedDashboardsEnabled;
  const expandedItemSet = props.expandedItemSet;
  const deepLevel = props.deepLevel || 0;
  const parentItemId = props.parentItemId || "";
  const nestedOrder = props.nestedOrder || NestingOrder.First;
  const itemId = parentItemId ? "".concat(parentItemId, "-").concat(item.value) : "".concat(sectionIdx, "-").concat(item.value);
  const nestedItemsToShow = expandedItemSet.has(itemId) && (_item$nestedItems = item.nestedItems) !== null && _item$nestedItems !== void 0 && _item$nestedItems.length ? item.nestedItems : [];
  return /* @__PURE__ */ jsx("div", { sel: ".sidenav-item", "data-sentry-component": "SidenavItemWithNestedItems", "data-sentry-source-file": "template.tsx" }, /* @__PURE__ */ jsx(SidenavItemEl, { attrs: _objectSpread(_objectSpread({}, selectedItemValue && {
    "is-selected": item.value === selectedItemValue
  }), {}, {
    "is-new": item.isNew && !(hoveredItemValues !== null && hoveredItemValues !== void 0 && hoveredItemValues.has(item.value)),
    "is-draggable": section.dragDropEnabled,
    "is-drag-disabled": sectionDragDisabled,
    "can-drop-item": Number.isInteger(activeDragSectionIdx),
    "label-tab-size": deepLevel,
    "is-nested-dashboards-enabled": isNestedDashboardsEnabled,
    "can-expand": ((_item$nestedItems2 = item.nestedItems) === null || _item$nestedItems2 === void 0 ? void 0 : _item$nestedItems2.length) > 0,
    "is-expanded": expandedItemSet.has(itemId),
    "nested-order": nestedOrder
  }), on: {
    itemDrop: onItemDrop,
    itemDragStart: onItemDragStart,
    itemDragEnd: onItemDragEnd,
    itemClick: onSelectItem,
    itemExpand: toggleItemChildren,
    overflowMenuChange: onItemOverflowMenuChange,
    overflowMenuSelect: onItemOverflowMenuSelect,
    mouseenter: () => onItemMouseEntered(item)
  }, props: {
    preventDefaultNavigate,
    item: _objectSpread(_objectSpread({}, item), {}, {
      itemIdx: idx,
      sectionIdx,
      itemId
    })
  }, "data-sentry-element": "SidenavItemEl", "data-sentry-source-file": "template.tsx" }), /* @__PURE__ */ jsx("div", { sel: ".sidenav-nested-items", class: {
    "is-selected": selectedItemValue && selectedItemValue === item.value
  } }, nestedItemsToShow.map((subItem, index) => /* @__PURE__ */ jsx(SidenavItemWithNestedItems, { section, item: subItem, sectionIdx, idx, selectedItemValue, hoveredItemValues, sectionDragDisabled, activeDragSectionIdx, onItemDrop, onItemDragStart, onItemDragEnd, onSelectItem, toggleItemChildren, onItemOverflowMenuChange, onItemOverflowMenuSelect, onItemMouseEntered, preventDefaultNavigate, deepLevel: deepLevel + 1, isNestedDashboardsEnabled, expandedItemSet, parentItemId: itemId, nestedOrder: index === item.nestedItems.length - 1 && (nestedOrder === NestingOrder.Last || nestedOrder === NestingOrder.First) ? NestingOrder.Last : NestingOrder.Middle }))));
}
function SidenavSection(props, sectionItemsChildren) {
  const section = props.section;
  const sectionDragDisabled = props.sectionDragDisabled;
  const isExpanded = props.isExpanded;
  const onToggleSection = props.onToggleSection;
  const {
    print
  } = props.i18n;
  const isSectionCollapsible = section.label && section.isCollapsible;
  return /* @__PURE__ */ jsx("div", { sel: ".section", attrs: {
    elref: "sidenavSection"
  }, class: {
    "active-dragging-disabled": sectionDragDisabled
  }, "data-sentry-component": "SidenavSection", "data-sentry-source-file": "template.tsx" }, section.label && /* @__PURE__ */ jsx("div", { sel: ".section-header", attrs: {
    elref: "sidenavSectionHeader",
    tabindex: 0
  }, on: isSectionCollapsible && {
    click: onToggleSection,
    keypress: handleKeyPress
  }, class: {
    "is-collapsible": isSectionCollapsible
  } }, /* @__PURE__ */ jsx(SvgIconEl, { attrs: {
    icon: isExpanded ? "caret-down" : "caret-right"
  } }), /* @__PURE__ */ jsx("div", { sel: ".section-header-label" }, print(section.label))), isExpanded && /* @__PURE__ */ jsx("div", { sel: ".section-items-list", attrs: {
    role: "list"
  } }, sectionItemsChildren));
}
export function template() {
  const sections = this.state.sections;
  const {
    print
  } = this.getContext("i18n");
  const selectedItemValue = this.helpers.getSelectedValue();
  const sidenavContent = this.attr("loading") ? /* @__PURE__ */ jsx(Loader, null) : sections.map((section, sectionIdx) => {
    const sectionDragDisabled = Number.isInteger(this.state.activeDragSectionIdx) && this.state.activeDragSectionIdx !== sectionIdx;
    const isExpanded = !this.state.collapsedSectionSet.has(section.key || print(section.label));
    if (section.items.length === 0) {
      return null;
    }
    return /* @__PURE__ */ jsx(SidenavSection, { section, sectionDragDisabled, isExpanded, onToggleSection: () => this.helpers.toggleSection(section), i18n: this.getContext("i18n") }, isExpanded && section.items.filter((item) => {
      var _this$getContext$get$;
      return !item.featureFlag || ((_this$getContext$get$ = this.getContext("currentProject").get().value) === null || _this$getContext$get$ === void 0 ? void 0 : _this$getContext$get$.hasFeatureFlag(item.featureFlag));
    }).map((item, idx) => /* @__PURE__ */ jsx("div", { sel: ".sidenav-item .sidenav-nested-items", class: _objectSpread(_objectSpread({}, selectedItemValue && {
      "is-selected": selectedItemValue === item.value
    }), {}, {
      "is-child-selected": selectedItemValue && this.isItemOrChildSelected(item, selectedItemValue)
    }), attrs: {
      role: "listitem",
      "aria-label": print(item.label),
      value: item.value
    }, hook: {
      insert: this.helpers.handleSidenavItemInserted
    } }, /* @__PURE__ */ jsx(SidenavItemWithNestedItems, { section, item, idx, sectionIdx, selectedItemValue, hoveredItemValues: this.state.hoveredItemValues, sectionDragDisabled, activeDragSectionIdx: this.state.activeDragSectionIdx, onItemDrop: this.helpers.onItemDrop, onItemDragStart: this.helpers.onItemDragStart, onItemDragEnd: this.helpers.onItemDragEnd, onSelectItem: this.helpers.onSelectItem, toggleItemChildren: this.helpers.toggleItemChildren, onItemOverflowMenuChange: this.helpers.onItemOverflowMenuChange, onItemOverflowMenuSelect: this.helpers.onItemOverflowMenuSelect, onItemMouseEntered: this.helpers.onItemMouseEntered, preventDefaultNavigate: this.preventDefaultNavigate, isNestedDashboardsEnabled: this.attr("is-nested-dashboards-enabled"), expandedItemSet: this.state.expandedItemSet }))));
  });
  return /* @__PURE__ */ jsx("div", { sel: ".sidebar", "data-sentry-component": "template", "data-sentry-source-file": "template.tsx" }, /* @__PURE__ */ jsx("div", { sel: ".wrapper" }, /* @__PURE__ */ jsx("div", { sel: ".sections-container", hook: {
    insert: this.helpers.onSectionsInserted
  }, attrs: {
    elref: "sectionsContainer"
  } }, /* @__PURE__ */ jsx("div", { sel: ".sections" }, sidenavContent))));
}
